import type { Beast, BeastState } from '../../../models/Beast';
import type { Surroundings } from '../../../models/Surroundings';
import type { IBeastState } from './IBeastState';
import { BEAST } from '../../../models/constants';
import { BeastExploringState } from './BeastExploringState';
import { BeastSleepingState } from './BeastSleepingState';

export class BeastEatingState implements IBeastState {
    static readonly stateName = 'Beast Eating';

    get allowInterrupt(): boolean {
        return false;
    }

    canEnter(beast: Beast, surroundings: Surroundings): boolean {
        return beast.health < BEAST.HUNGER_THRESHOLD && surroundings.availableFood > 0;
    }

    tick(beast: Beast, surroundings: Surroundings): BeastState {
        if (surroundings.availableFood <= 0) return BeastExploringState.stateName;

        beast.setHealth(beast.health + BEAST.FOOD_RATE);

        if (beast.health >= BEAST.FULL_THRESHOLD) {
            beast.sleepTicks = BEAST.SLEEP_TICKS;
            return BeastSleepingState.stateName;
        }

        return BeastEatingState.stateName;
    }
}
